/* DON'T EDIT THIS FILE: edit original and run build again */ export const padDayOrMonth = (n: number) => String(n).padStart(2, "0");
